import { emailsApi } from "api/emailsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useEmails = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.EMAILS(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => emailsApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.EMAILS(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, emails: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export const useEmail = (id: number | null) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.EMAIL(id ?? 0),
    queryFn: () => emailsApi.fetchById(id!),
    enabled: !!id,
  });

  return { isLoading, email: data?.data };
};
